<template>
  <router-link class="card-menu" :to="{ path: link }">
    <div class="image-text-base">
      <div class="image">
        <img
          :src="require(`@/assets/menus/${src}`)"
          alt="submenu image"
          :style="{
            height: 80 + 'px',
            width: 80 + 'px',
            borderRadius: 12 + 'px',
          }"
        />
      </div>
      <div class="texts">
        <div class="title">{{ title }}</div>
        <div class="subtitle">{{ subtitle }}</div>
      </div>
    </div>

    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        fill="currentColor"
        class="bi bi-arrow-right-short site-nav-dropdown-arrow"
        viewBox="0 0 16 16"
      >
        <path
          fill-rule="evenodd"
          d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"
        />
      </svg>
    </div>
  </router-link>
</template>
<script>
export default {
  name: "CardNavBar",
  props: {
    src: String,
    title: String,
    subtitle: String,
    link: String,
  },
};
</script>

<style lang="scss" scoped>
.card-menu {
  align-items: center;
  border-radius: 12px;
  display: flex;
  margin: 0 10px;
  padding: 3px 2px;
  text-decoration: none;
  transition: background-color 200ms ease;
  &:hover {
    background-color: $color-primary;
    color: $color-secondary;
    text-decoration: underline;
  }
}
.image-text-base {
  align-items: flex-start;
  display: flex;
}

.image {
  align-items: center;
  display: flex;
  justify-content: center;
  margin-right: 10px;
}
.texts {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.title {
  font-size: $font-size-normal;
  font-weight: 600;
  padding-bottom: 0.4rem;
}
.subtitle {
  display: -webkit-box;
  font-size: 0.9rem;
  line-height: 16px;
  overflow: hidden;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.card-menu:hover .site-nav-dropdown-arrow {
  opacity: 1;
  transform: translateX(4px);
}
.site-nav-dropdown-arrow {
  opacity: 0;
  transition: transform 200ms ease-in, opacity 200ms ease-in;
}
</style>
